.scroll-invisible {
    overflow: auto;
    max-height: 50vh;
}

.scroll-invisible::-webkit-scrollbar {
    width: 0;
}

.scroll-invisible::-webkit-scrollbar-thumb {
    background: transparent;
}

.container-loading {
    width: 100%;
}

.subtitle-color {
    color: #6c757d;
}

.legend-title {
    position: relative;
    -webkit-margin-after: 1rem;
    margin-block-end: 1rem;
}

.legend-title::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 0.1rem;
    border-radius: 3.125rem;
    background-image: linear-gradient(to right, rgb(var(--primary-rgb)), rgba(var(--primary-rgb), 0.2));
    inset-block-end: -0.625rem;
    /* inset-inline-start: 0.375rem; */
}

